/**
 * 时间转换工具函数
 */

/**
 * 将 UTC 时间字符串转换为东八区时间字符串
 * @param {string} utcTimeString - UTC 时间字符串
 * @param {boolean} includeTime - 是否包含时间部分
 * @returns {string} 东八区时间字符串
 */
export function formatUTCToBeijing(utcTimeString, includeTime = true) {
  if (!utcTimeString) return '-';

  try {
    const utcDate = new Date(utcTimeString);

    if (includeTime) {
      return utcDate.toLocaleString('zh-CN', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
    } else {
      return utcDate.toLocaleDateString('zh-CN', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  } catch (error) {
    console.error('时间转换失败:', error);
    return utcTimeString;
  }
}

/**
 * 将 UTC 时间字符串转换为相对时间（如：3分钟前）
 * @param {string} utcTimeString - UTC 时间字符串
 * @returns {string} 相对时间字符串
 */
export function formatRelativeTime(utcTimeString) {
  if (!utcTimeString) return '-';

  try {
    const utcDate = new Date(utcTimeString);
    const now = new Date();
    const diff = now.getTime() - utcDate.getTime();

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (seconds < 60) return '刚刚';
    if (minutes < 60) return `${minutes}分钟前`;
    if (hours < 24) return `${hours}小时前`;
    if (days < 7) return `${days}天前`;
    return formatUTCToBeijing(utcTimeString, false);
  } catch (error) {
    console.error('相对时间转换失败:', error);
    return utcTimeString;
  }
}
